import * as React from 'react';
import NotificationSystem from 'react-notification-system';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';

import { removeError, removeNotification } from '@actions/appState';

import './style.scss';

interface IAlertProps extends ICommonProps {
  alerts: IAlert[];
  removeError: TRemoveError;
  removeNotification: TRemoveNotification;
}

export class Alert extends React.Component<IAlertProps, {}> {
  notificationSystem: any;
  readonly alertTimeout: number = 3000;
  readonly dismissableAlertTimeout: number = 10000;

  componentWillReceiveProps(nextProps: IAlertProps) {
    const prevAlerts = this.props.alerts;
    const newAlerts = nextProps.alerts;

    const hasAlertsChanged = prevAlerts !== newAlerts;
    const isClearAll = !newAlerts || newAlerts.length === 0;

    if (hasAlertsChanged) {
      if (isClearAll) {
        this.notificationSystem.clearNotifications();
      } else {
        newAlerts.map((newAlert) => {
          const isAlertShown = prevAlerts && prevAlerts.some((prevAlert) => prevAlert.key === newAlert.key);

          if (!isAlertShown) {
            newAlert.type === AlertLevel.ERROR ? this.addError(newAlert) : this.addSuccess(newAlert);
          }
        });
      }
    }
  }

  removeError = (key: any) => {
    this.props.removeError(key);
    this.notificationSystem.removeNotification(key);
  };

  removeSuccess = (key: any) => {
    this.props.removeNotification(key);
    this.notificationSystem.removeNotification(key);
  };

  addError = (error: IAlert) => {
    if (error.message.length > 0) {
      this.notificationSystem.addNotification({
        message: error.message,
        uid: error.key,
        level: 'error',
        autoDismiss: 0,
        position: 'tc',
        dismissible: error.isDismissible ? 'button' : false,
      });

      setTimeout(
        () => this.removeError(error.key),
        error.isDismissible ? this.dismissableAlertTimeout : this.alertTimeout
      );
    }
  };

  addSuccess = (notification: IAlert) => {
    this.notificationSystem.addNotification({
      uid: notification.key,
      level: 'success',
      autoDismiss: 0,
      position: 'tc',
      dismissible: false,
      children: (
        <div className={classnames('success-custom-message')}>
          <img src="/assets/tick-icon.png" alt="" aria-hidden="true" />
          <span>{notification.message}</span>
        </div>
      ),
    });

    setTimeout(
      () => this.removeSuccess(notification.key),
      notification.isDismissible ? this.dismissableAlertTimeout : this.alertTimeout
    );
  };

  render() {
    const NotificationStyle: any = {
      Containers: {
        tc: {
          top: '90px',
          left: '50%',
          zIndex: 99989,
          transform: 'translateX(-50%)',
          width: 'unset',
          display: 'flex',
          flexDirection: 'column',
        },
      },
      NotificationItem: {
        DefaultStyle: {
          padding: '4px 22px 4px 22px',
          border: 0,
          borderRadius: 4,
          display: 'inline-block',
          width: 'unset',
          fontFamily: 'Montserrat',
          fontSize: 14,
          whiteSpace: 'nowrap',
          textAlign: 'center',
          backgroundColor: '#ffffff',
          color: '#1f2937',
        },
        error: {
          backgroundColor: '#c00000',
          color: '#ffffff',
          fontWeight: 600,
        },
        success: {
          backgroundColor: '#008000',
          color: '#ffffff',
          fontWeight: 600,
        },
        warning: {
          backgroundColor: '#7a4b00',
          color: '#ffffff',
          fontWeight: 600,
        },
        info: {
          backgroundColor: '#005a8c',
          color: '#ffffff',
          fontWeight: 600,
        },
      },
      Title: {
        DefaultStyle: {
          color: 'inherit',
        },
      },
      MessageWrapper: {
        DefaultStyle: {
          color: 'inherit',
        },
      },
      Dismiss: {
        DefaultStyle: {
          cursor: 'pointer',
          fontFamily: 'Arial',
          fontSize: '17px',
          position: 'absolute',
          top: '7px',
          right: '5px',
          lineHeight: '15px',
          backgroundColor: 'transparent',
          color: '#ffffff',
          borderRadius: '50%',
          width: '14px',
          height: '14px',
          fontWeight: 'bold',
          textAlign: 'center',
        },

        success: {
          color: '#ffffff',
        },

        error: {
          color: '#ffffff',
        },

        warning: {
          color: '#ffffff',
        },

        info: {
          color: '#ffffff',
        },
      },
    };

    return (
      <div role="region" aria-label="Notifications">
        <NotificationSystem ref={(r) => (this.notificationSystem = r)} style={NotificationStyle} />
      </div>
    );
  }
}

const mapStateToProps = (state: IReduxStore) => ({
  alerts: state.appState.alerts,
});

const mapDispatchToProps = (dispatch: any) => ({
  removeError: (key: string) => dispatch(removeError(key)),
  removeNotification: (key: string) => dispatch(removeNotification(key)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Alert));
